import OpportunityTypes from '@helpers/opportunity-types';

export const isUnlistedOpportunityType = (opportunityType) => opportunityType === OpportunityTypes.UNLISTED_SECURITISED_DEBT_INSTRUMENT;